//=require ../utils.js

class FP_Subscription_Form {
	constructor() {
		this.init();
	}

	init() {
		document.addEventListener('click', (e) => {
			this.subscribe(e);
		});
	}

	/**
	 * Subscribe user
	 * 
	 * @param   {Event}   e 
	 */
	subscribe(e) {
		let button = e.target.closest('.subscription_button');
		if (!button) {
			return;
		}

		e.preventDefault();

		let form = e.target.closest('.fp-subscription-form');
		
		let name = form.querySelector('input[name="name"]');
		if (name) {
			// validate name if empty locally
			if (name.value.trim() == '') {
				this.showMessage(form, button.dataset.missingName, 'error');
				return;
			}
		}

		// validate email if empty locally
		let email = form.querySelector('input[type="email"]');
		if (email.value.trim() == '') {
			this.showMessage(form, button.dataset.missingEmail, 'error');
			return;
		}

		this.hideMessage(form);

		const initialText = button.dataset.initialText;
		const loadingText = button.dataset.loadingText;

		// set button status to loading
		button.innerHTML = loadingText;
		button.classList.add('disabled');

		let lists = form.querySelector('input[type="hidden"][name="lists"]');
		let url = new URL(fireplugins.site_url + '?page=acymailing_front&ctrl=frontusers&task=subscribe&hiddenlists=' + lists.value + '&user[email]=' + email.value + '&action=acymailing_frontrouter&ajax=1');

		fetch(url)
		.then(function(response) {
			return response.json();
		})
		.then((resp) => {
			const type = resp.type == 'error' ? 'error' : 'success';
			this.showMessage(form, resp.message, type);

			// reset button status
			button.classList.remove('disabled');
			button.innerHTML = initialText;

			if (resp.type != 'error') {
				// reset email field
				email.value = '';
			}
		});
	}

	/**
	 * Show message (error or success).
	 * 
	 * @param   {HTMLElement}  form 
	 * @param   {String}	   message 
	 * @param   {String}	   type 
	 * 
	 * @return  void
	 */
	showMessage(form, message, type) {
		let messages = form.querySelector('.messages');
		messages.classList.remove('errors', 'success');

		messages.classList.add(type);
		messages.innerHTML = message;
		messages.classList.add('is-visible');
	}

	/**
	 * Hides message.
	 * 
	 * @param   {HTMLElement}  form 
	 * 
	 * @return  void
	 */
	hideMessage(form) {
		form.querySelector('.messages').innerHTML = '';
	}
}

FP_Utils.onReady(function() {
	new FP_Subscription_Form();
});